module.exports = __webpack_public_path__ + "static/media/img_chengben@2x.e6738281.png";